import React, { useState, useEffect, useCallback } from 'react';
import API from '../services/api';
import Modal from '../components/Modal';

const bugun = () => { const d = new Date(); const p = n => String(n).padStart(2,'0'); return `${d.getFullYear()}-${p(d.getMonth()+1)}-${p(d.getDate())}`; };
const trTarih = s => s ? new Date(s).toLocaleDateString('tr-TR') : '—';
const trTutar = v => (v ?? 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 });

export default function Faturalar() {
  const [bas, setBas] = useState(bugun());
  const [bit, setBit] = useState(bugun());
  const [data, setData] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [modal, setModal] = useState(null);
  const [detay, setDetay] = useState(null);
  const [detayYukleniyor, setDetayYukleniyor] = useState(false);

  useEffect(() => {
    if (!modal) { setDetay(null); return; }
    setDetayYukleniyor(true);
    API.get(`/Finans/fatura/${modal.protNo}`)
      .then(r => setDetay(r.data))
      .catch(() => setDetay(null))
      .finally(() => setDetayYukleniyor(false));
  }, [modal]);

  const yukle = useCallback((b, s) => {
    setYukleniyor(true);
    API.get('/Finans/faturalar', { params: { bas: b, bit: s } })
      .then(r => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setYukleniyor(false));
  }, []);

  useEffect(() => { yukle(bas, bit); }, []); // eslint-disable-line

  return (
    <div>
      <h1 className="sayfa-baslik">Faturalar</h1>
      <p className="sayfa-alt">Dönemsel fatura listesi (REFERANS tablosu).</p>

      <form onSubmit={e => { e.preventDefault(); yukle(bas, bit); }}
            style={{ display:'flex', gap:12, alignItems:'flex-end', flexWrap:'wrap', marginBottom:18 }}>
        <div className="form-row"><div className="form-label">Başlangıç</div>
          <input type="date" className="input" value={bas} onChange={e => setBas(e.target.value)} /></div>
        <div className="form-row"><div className="form-label">Bitiş</div>
          <input type="date" className="input" value={bit} onChange={e => setBit(e.target.value)} /></div>
        <button className="btn" type="submit">Listele</button>
      </form>

      {!yukleniyor && data && (
        <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:14 }}>
          <span className="bilgi-rozet">📄 {data.liste.length} fatura</span>
          <span className="bilgi-rozet" style={{ fontWeight:700 }}>Toplam: {trTutar(data.toplam)} ₺</span>
        </div>
      )}

      <div className="kart" style={{ overflow:'hidden' }}>
        {yukleniyor ? <div className="bos-durum">Yükleniyor…</div>
          : !data || data.liste.length === 0 ? <div className="bos-durum">Bu dönemde fatura bulunamadı.</div>
          : (
          <table className="tablo">
            <thead><tr>
              <th style={{ width:110 }}>Tarih</th>
              <th>Hasta / Cari</th>
              <th style={{ width:140, textAlign:'right' }}>Tutar</th>
            </tr></thead>
            <tbody>
              {data.liste.map((r, i) => (
                <tr key={i} onClick={() => setModal(r)} style={{ cursor:'pointer' }}>
                  <td>{trTarih(r.tar)}</td>
                  <td style={{ fontWeight:600 }}>{r.adSoy || '—'}</td>
                  <td style={{ textAlign:'right', fontWeight:600, color:'var(--mor)' }}>{trTutar(r.tutar)} ₺</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {modal && (
        <Modal baslik="Fatura Detayı" onKapat={() => setModal(null)}>
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            <div><strong>Tarih:</strong> {trTarih(modal.tar)}</div>
            <div><strong>Tutar:</strong> {trTutar(modal.tutar)} ₺</div>
            <div><strong>Hasta:</strong> {modal.adSoy || '—'}</div>

            <div style={{ marginTop: 10 }}>
              {detayYukleniyor ? (
                <div style={{ color: 'var(--metin-soluk)', fontSize: 13 }}>Kalemler yükleniyor…</div>
              ) : detay?.kalemler?.length > 0 ? (
                <table className="tablo">
                  <thead><tr>
                    <th>Hizmet Adı</th>
                    <th style={{ width: 110, textAlign: 'right' }}>B.Fiyat</th>
                  </tr></thead>
                  <tbody>
                    {detay.kalemler.map((k, i) => (
                      <tr key={i}>
                        <td>{k.hizmet}</td>
                        <td style={{ textAlign: 'right' }}>{trTutar(k.bFiyat)} ₺</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div style={{ color: 'var(--metin-soluk)', fontSize: 13 }}>Bu faturaya ait kalem bulunamadı.</div>
              )}
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
